import { Box, Button, Typography } from '@mui/material';
import { TabContext } from '@mui/lab';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useGeneralSearch } from '../../hooks/use-general-search.hook';
import {
  EmptyContainer,
  OptionsContainer,
  StyledTab,
  StyledTabPanel,
  StyledTabs,
} from '../../styles';
import { ResultList } from '../result-list';
import { ModalFixedIncome } from '@mais-retorno-front/components/income-fixed-modal';

interface ICategory {
  slug: string;
  label: string;
  disabled: boolean;
}

interface IAssetInfo {
  slug: string;
  displayName: string;
  value: string | number;
}

interface IFormattedAsset {
  cnpj: number;
  identifier: string;
  slug: string;
  nicename: string;
  url: string;
  info: IAssetInfo[];
  type: string;
}

interface IAssetsByCategory {
  [category: string]: IFormattedAsset[];
}

interface SearchCategoriesProps {
  results: IAssetsByCategory;
  categories: ICategory[];
  loading: boolean;
  open: boolean;
  comparisonMode: boolean;
  incomeFixed: boolean;
  dialogMode?: boolean;
  floatingMode?: boolean;
  onOpen?: (status: boolean) => void;
  handleCloseDialog: () => void;
  clearInput: () => void;
}

export const ResultsByCategory = ({
  results,
  categories,
  loading,
  open,
  floatingMode = false,
  dialogMode = false,
  comparisonMode,
  incomeFixed,
  onOpen = () => {},
  handleCloseDialog,
  clearInput,
}: SearchCategoriesProps) => {
  const [currentTab, setCurrentTab] = useState(categories[0].slug);
  const incomeFixedModalRef = useRef<any>(null);
  const { addNewAsset } = useGeneralSearch();

  const onAddSuccessIncomeFixed = useCallback(
    (incomeFixed: string, { nicename }) => {
      addNewAsset({
        cnpj: null,
        nicename,
        identifier: incomeFixed,
        slug: incomeFixed,
        type: '',
        url: '',
        info: null,
      });

      incomeFixedModalRef?.current?.setOpenDialog(false);
    },
    [incomeFixedModalRef]
  );

  useEffect(() => {
    setCurrentTab(categories[0].slug);
  }, [categories]);

  return (
    <>
      {open ? (
        <>
          <TabContext value={currentTab}>
            <OptionsContainer
              floatingmode={floatingMode?.toString()}
              dialogmode={dialogMode?.toString()}
            >
              {incomeFixed && (
                <Box bgcolor="white" p={1}>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={() =>
                      incomeFixedModalRef.current.setOpenDialog(true)
                    }
                  >
                    Adicionar Renda fixa
                  </Button>
                </Box>
              )}
              <StyledTabs
                value={currentTab}
                onChange={(e, value) => setCurrentTab(value)}
                TabIndicatorProps={{ hidden: true }}
                selectionFollowsFocus
                variant="scrollable"
                scrollButtons="auto"
              >
                {categories.map((category) => (
                  <StyledTab
                    disableRipple
                    key={category.slug}
                    label={category.label}
                    value={category.slug}
                    disabled={category.disabled}
                  />
                ))}
              </StyledTabs>

              {loading ? (
                <EmptyContainer>
                  <Typography color="#333">Buscando resultados...</Typography>
                </EmptyContainer>
              ) : (
                <>
                  {Object.keys(results).map((key) => (
                    <StyledTabPanel
                      floatingmode={floatingMode?.toString()}
                      key={key}
                      value={key}
                    >
                      {!!results[key].length ? (
                        <ResultList
                          onOpen={onOpen}
                          assets={results[key]}
                          handleCloseDialog={handleCloseDialog}
                          clearInput={clearInput}
                          comparisonMode={comparisonMode}
                        />
                      ) : (
                        <EmptyContainer>
                          <Typography>
                            Não foi possível encontrar resultado para a busca
                          </Typography>
                        </EmptyContainer>
                      )}
                    </StyledTabPanel>
                  ))}
                </>
              )}
            </OptionsContainer>
          </TabContext>
        </>
      ) : null}
      <ModalFixedIncome
        ref={incomeFixedModalRef}
        onSuccess={onAddSuccessIncomeFixed}
      />
    </>
  );
};
